import React from "react";
import { useTheme } from "src/context/theme.context";

type Props = {
  rows?: number;
};

const Cell = ({ className, isDarkMode }: { className: string; isDarkMode: boolean }) => (
  <div className={`h-3 rounded animate-pulse ${isDarkMode ? "bg-gray-700" : "bg-gray-200"} ${className}`} />
);

export const WithdrawalRequestsTableSkeleton: React.FC<Props> = ({ rows = 10 }) => {
  const { isDarkMode } = useTheme();

  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr
          key={i}
          className={`text-center ${isDarkMode ? "odd:bg-gray-900 even:bg-gray-800" : "odd:bg-white even:bg-gray-50"}`}
        >
          <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
            <Cell className="w-24 mx-auto" isDarkMode={isDarkMode} />
          </td>
          <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
            <Cell className="w-32 mx-auto" isDarkMode={isDarkMode} />
          </td>
          <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
            <div className="flex justify-center">
              <div className={`h-5 w-16 rounded-full animate-pulse ${isDarkMode ? "bg-gray-700" : "bg-gray-200"}`} />
            </div>
          </td>
          <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
            <div className="flex justify-center">
              <div className={`h-5 w-20 rounded-full animate-pulse ${isDarkMode ? "bg-gray-700" : "bg-gray-200"}`} />
            </div>
          </td>
          <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
            <Cell className="w-20 mx-auto" isDarkMode={isDarkMode} />
          </td>
          <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
            <div className="flex justify-center">
              <div className={`h-5 w-16 rounded-full animate-pulse ${isDarkMode ? "bg-gray-700" : "bg-gray-200"}`} />
            </div>
          </td>
          <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
            <Cell className="w-24 mx-auto" isDarkMode={isDarkMode} />
          </td>
          <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
            <div className="flex justify-center gap-2">
              <div className={`h-8 w-16 rounded animate-pulse ${isDarkMode ? "bg-gray-700" : "bg-gray-200"}`} />
              <div className={`h-8 w-16 rounded animate-pulse ${isDarkMode ? "bg-gray-700" : "bg-gray-200"}`} />
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default WithdrawalRequestsTableSkeleton;
